import type React from "react";

import { useTodoVM } from "../Root.js";
import { LiveValue } from "./LiveValue.tsx";

export const Header: React.FC = () => {
  const vm = useTodoVM();

  return (
    <header data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:10:13" data-name="header" className="header">
      <h1 data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:11:11" data-name="h1">TodoMVC</h1>
      <LiveValue query={vm.header.newTodoText$}>
        {(newTodoText) => (
          <input
            data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:15:13" data-name="input" className="new-todo"
            placeholder="What needs to be done?"
            value={newTodoText}
            onChange={(e) => vm.header.updateNewTodoText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                vm.header.addTodo();
              }
            }}
          />
        )}
      </LiveValue>
    </header>
  );
};
